module.exports = __webpack_public_path__ + "static/media/oleo-corporal.7f86f030.png";